<template>
  <div id="catalog" class="section_catalog">
    <p class="title_bid_form">
      КАТАЛОГ <span class="color_orange">МЕБЕЛИ</span>
    </p>
    <div class="catalog">
      <nav>
        <ul class="nav_catalog">
          <li
            v-for="(item, key) in categories"
            :key="key"
            @click="selectedCategory = key"
            class="li_button"
            :class="{ active: selectedCategory === key }"
          >
            {{ item.name }}
          </li>
        </ul>
      </nav>

      <div class="content">
        <div class="image-container">
          <img
            :src="categories[selectedCategory].image"
            alt="Category Image"
            class="category-image"
          />
          <div
            v-for="(marker, index) in categories[selectedCategory].markers"
            :key="index"
            class="marker"
            :style="{ top: marker.y + '%', left: marker.x + '%' }"
            @mouseover="hoveredMarker = index"
            @mouseleave="hoveredMarker = null"
          >
            <div class="marker_mini"></div>

            <!-- Текст -->
            <p
              class="text_marcer"
              :class="{ text_hover: hoveredMarker === index }"
            >
              {{ marker.text }}
            </p>

            <!-- SVG class="marker-svg" -->
            <img src="@/assets/img/icon/vector.svg" class="marker-svg" />
          </div>
        </div>
        <div class="description">
          <h2
            class="title_catalog"
            v-html="categories[selectedCategory].title"
          ></h2>
          <p
            class="selectedCategory_catalog"
            v-html="categories[selectedCategory].description"
          ></p>
          <div
            v-html="categories[selectedCategory].htmlDescription"
            class="sub_text_catalog"
          ></div>
          <div class="box_button_catalog">
            <button class="button_catalog" @click="toggleCart">
              <span>ПОДРОБНЕЕ</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import kitchen from "@/assets/img/catalog/kitchen.webp";
import { useCartStore } from "@/store/cartStore";
import wardrobe from "@/assets/img/catalog/Wardrobe.webp";
import cabinets from "@/assets/img/catalog/cabinets.webp";
import hallways from "@/assets/img/catalog/Hallway.webp";
import living_rooms from "@/assets/img/catalog/Living_room.webp";
import bedrooms from "@/assets/img/catalog/bedroom.webp";
import for_business from "@/assets/img/catalog/for_business.webp";

const cartStore = useCartStore();
const toggleCart = cartStore.toggleCart;

const categories = ref({
  kitchens: {
    name: "Кухни",
    title: "Мебель для <span class='color_orange'>кухни</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    htmlDescription: `
      <ul>
        <li>Материал корпуса: ЛДСП</li>
        <li>Декор корпуса: Кашемир</li>
        <li>Фасады: МДФ</li>
      </ul>
    `,
    image: kitchen,
    markers: [
      { x: 30, y: 40, text: "Столешница" },
      { x: 60, y: 70, text: "Шкафчики" },
    ],
  },
  wardrobe: {
    name: "Гардероб",
    title: "Мебель для <span class='color_orange'>гардероба</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    htmlDescription: `
      <ul>
        <li>Материал корпуса: ЛДСП</li>
        <li>Декор корпуса: Кашемир</li>
        <li>Фасады: МДФ</li>
      </ul>
    `,
    image: wardrobe,
    markers: [
      { x: 30, y: 40, text: "Столешница" },
      { x: 60, y: 70, text: "Шкафчики" },
    ],
  },

  cabinets: {
    name: "Шкафы",
    title: "<span class='color_orange'>Шкафы</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    htmlDescription: `
      <ul>
        <li>Материал корпуса: ЛДСП</li>
        <li>Декор корпуса: Кашемир</li>
        <li>Фасады: МДФ</li>
      </ul>
    `,
    image: cabinets,
    markers: [
      { x: 30, y: 40, text: "Столешница" },
      { x: 60, y: 70, text: "Шкафчики" },
    ],
  },

  hallways: {
    name: "Прихожие",
    title: "Мебель для <span class='color_orange'>прихожей</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    htmlDescription: `
      <ul>
        <li>Материал корпуса: ЛДСП</li>
        <li>Декор корпуса: Кашемир</li>
        <li>Фасады: МДФ</li>
      </ul>
    `,
    image: hallways,
    markers: [
      { x: 30, y: 40, text: "Столешница" },
      { x: 60, y: 70, text: "Шкафчики" },
    ],
  },
  living_rooms: {
    name: "Гостинные",
    title: "Мебель для <span class='color_orange'>гостинной</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    htmlDescription: `
      <ul>
        <li>Материал корпуса: ЛДСП</li>
        <li>Декор корпуса: Кашемир</li>
        <li>Фасады: МДФ</li>
      </ul>
    `,
    image: living_rooms,
    markers: [
      { x: 30, y: 40, text: "Столешница" },
      { x: 60, y: 70, text: "Шкафчики" },
    ],
  },

  bedrooms: {
    name: "Спальни",
    title: "Мебель для <span class='color_orange'>спальни</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    htmlDescription: `
      <ul>
        <li>Материал корпуса: ЛДСП</li>
        <li>Декор корпуса: Кашемир</li>
        <li>Фасады: МДФ</li>
      </ul>
    `,
    image: bedrooms,
    markers: [
      { x: 30, y: 40, text: "Столешница" },
      { x: 60, y: 70, text: "Шкафчики" },
    ],
  },

  for_business: {
    name: "Для бизнеса",
    title: "Мебель для <span class='color_orange'>офисов</span>",
    description:
      "<span style='font-weight: 700;'>Опытные дизайнеры</span> со стажем от 10 лет <br/> &nbsp; <br/> <span style='font-weight: 700;'>Бесплатный замер</span> и проектирование <br/> &nbsp; <br/> <span style='font-weight: 700;'>Высокое качество</span> материалов",
    htmlDescription: `
      <ul>
        <li>Материал корпуса: ЛДСП</li>
        <li>Декор корпуса: Кашемир</li>
        <li>Фасады: МДФ</li>
      </ul>
    `,
    image: for_business,
    markers: [
      { x: 30, y: 40, text: "Столешница" },
      { x: 60, y: 70, text: "Шкафчики" },
    ],
  },
});
const hoveredMarker = ref(null);
const selectedCategory = ref("kitchens");
</script>

<style scoped>
.catalog {
  display: flex;
  flex-direction: column;
  gap: 4.25rem;
}

.nav_catalog {
  display: flex;
  justify-content: space-between;
}

.image-container {
  position: relative;
}
.category-image {
  width: 39.95rem;
  height: 28rem;
}
.marker {
  position: absolute;
  border: 0.05rem solid rgb(255, 255, 255);
  border-radius: 0.4rem;
  width: 0.8rem;
  height: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.marker_mini {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 0.4rem;
  background: rgb(255, 255, 255);
  transition: all 0.2s ease;
}
.marker:hover .tooltip {
  display: block;
}
.tooltip {
  display: none;
  position: absolute;
  background: black;
  color: white;
  padding: 5px;
  border-radius: 5px;
  white-space: nowrap;
}
.section_catalog {
  background: rgb(255, 255, 255);
  width: 100%;
  padding: 6rem 8rem 8rem 8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.title_bid_form {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: 1.5%;
  text-align: left;
  text-transform: uppercase;
}
.li_button {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
  cursor: pointer;
  padding-bottom: 0.3rem;
  border-bottom: 0.05rem solid transparent;
  transition: 0.2s ease;
}
.li_button.active {
  color: rgb(245, 160, 62);
  border-bottom: 0.05rem solid rgb(51, 47, 47);
  transition: 0.2s ease;
}
.content {
  display: flex;
  gap: 13rem;
}
.title_catalog {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.6rem;
  letter-spacing: 0%;
  text-align: left;
  color: rgb(51, 47, 47);
  margin-bottom: 1rem;
}
.description {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  position: relative;
}
.sub_text_catalog {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
}
.box_button_catalog {
  position: absolute;
  bottom: 0px;
  left: 0px;
}
.button_catalog {
  border-radius: 4rem;
  background: linear-gradient(
    90deg,
    rgb(245, 160, 62),
    rgb(207, 117, 14) 102.477%
  );
  width: 13.35rem;
  height: 3rem;
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.button_catalog::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 204, 102, 0) 0%,
    rgba(255, 204, 102, 0.9) 50%,
    rgba(255, 204, 102, 0) 100%
  );
  filter: blur(4px);
  animation: wave 2s infinite linear;
  z-index: 0;
}
.button_catalog span {
  color: rgb(255, 255, 255);
  position: relative;
  z-index: 1;
}

.marker-svg {
  position: absolute;
  bottom: 1rem;
  left: 0.8rem;
  transition: all 0.2s ease;
  width: 10.75rem;
  height: 2rem;
}
.marker:hover .marker-svg {
  transform: scale(1.2);
  left: 2.5rem;
  bottom: 1.7rem;
  transition: all 0.2s ease;
}
.text_marcer {
  position: absolute;
  right: -10.8rem;
  bottom: 3rem;
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.15rem;
  letter-spacing: 0%;
  text-align: right;
  transition: all 0.2s ease;
}
.marker:hover .text_marcer {
  right: -13rem;
  bottom: 3.9rem;
  transition: all 0.2s ease;
}
.marker:hover {
  transition: all 0.2s ease;
  width: 1.4rem;
  height: 1.4rem;
}
.marker:hover .marker_mini {
  transition: all 0.2s ease;
  width: 0.9rem;
  height: 0.9rem;
}
.selectedCategory_catalog {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
}
@media (max-width: 767px) {
  .section_catalog {
    padding: 1.7rem 2.4rem 4rem 2.4rem;
  }
  .nav_catalog {
    gap: 1.5rem;
    row-gap: 0.8rem;
    flex-wrap: wrap;
  }
  .li_button {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.14rem;
  }
  .category-image {
    width: 100%;
    height: auto;
  }
  .content {
    flex-direction: column;
    gap: 1rem;
  }
  .button_catalog {
    position: relative;
    width: 16.5rem;
    height: 2.71rem;
    font-size: 0.71rem;
    font-weight: 700;
    line-height: 0.86rem;
  }
  .marker {
    display: none;
  }
  .catalog {
    gap: 1.5rem;
  }
  .title_bid_form {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 1.64rem;
  }
  .title_catalog {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 2.29rem;
  }
  .description {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    padding-bottom: 5rem;
  }
}
</style>
